import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

type ChangeCallbackFn = (event: unknown) => void;

@Component({
    selector: 'pace-forms-input-radio',
    templateUrl: './input-radio.component.html',
    styleUrls: ['./input-radio.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputRadioComponent),
            multi: true,
        },
    ],
    standalone: false,
})
export class InputRadioComponent implements ControlValueAccessor {
    @Input()
    public value: string;

    @Input()
    public label: string;

    @Input()
    public name: string;

    public disabled: boolean;
    public selectedValue: string;
    public onChanged: ChangeCallbackFn = () => undefined;
    public onTouched: VoidFunction = () => undefined;
    public constructor(private readonly cdr: ChangeDetectorRef) {}

    public registerOnChange(fn: VoidFunction): void {
        this.onChanged = fn;
    }

    public registerOnTouched(fn: VoidFunction): void {
        this.onTouched = fn;
    }

    public writeValue(val: string): void {
        this.selectedValue = val;
        this.cdr.detectChanges();
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
        this.cdr.detectChanges();
    }
}
